import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Solicitud, Usuario, FacturaDetalle } from '../../models';
import { finalize, Subject, takeUntil } from 'rxjs';
import { PerfilStore } from '../../store/perfil.store';
import { GestionSgmmService } from '../../services/gestion-sgmm.service';
import { saveAs } from 'file-saver';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { ImportsModule } from "../../imports.module";
@Component({
  selector: 'app-detalle-solicitud',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzDescriptionsModule,
    NzInputModule,
    NzIconModule,
    CurrencyPipe,
    DatePipe,
    NzSpinModule,
    NzAlertModule,
    NzPopoverModule,
    ImportsModule
],
  templateUrl: './detalle-solicitud.component.html',
  styleUrl: './detalle-solicitud.component.scss'
})
export class DetalleSolicitudComponent implements OnInit {

  constructor( private sessionStore: PerfilStore, private sgmmService : GestionSgmmService, private message: NzMessageService, private cdr: ChangeDetectorRef ) { }
  $onDestroy: Subject<void> = new Subject<void>();
  @Input() solicitud ?: Solicitud;
  detalle ?: FacturaDetalle[];
  observaciones: string = '';
  user ?: Usuario | null = null;
  loading : boolean = false;
  alertStatus = { success: false, info: false, error: false };
  loadingArchivos : boolean = false;
  ngOnInit(): void {
    this.sessionStore.getPerfil()
    .pipe(takeUntil(this.$onDestroy))
    .subscribe((user:Usuario | null) => {
      this.user = user;
    });
    this.loadingArchivos = true;
    this.sgmmService.obtenerDetalle( this.solicitud?.id! )
    .pipe(takeUntil(this.$onDestroy), finalize(() => {
      this.loadingArchivos = false;
      this.cdr.detectChanges();
    }))
    .subscribe({
      next: ( res: any ) => {
        if( res.success && res.details?.length > 0 ){
          this.detalle = res.details;
          this.cdr.detectChanges();
          this.obtenerLeyenda();
        }
      },
      error: ( err ) => {
        console.error(err);
      }
    });
  }

  getEstatusColor(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
        return '#00A226';
      case 'rechazado':
        return '#E31F42';
      case 'en revisión':
      case 'en revision':
      case 'proceso':
        return '#0234D7';
      case 'pendiente':
        return '#FFC01A';
      case 'pagado':
        return '#00A226';
      default:
        return '#0234D7';
    }
  }

  getEstatusIcon(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
      case 'pagado':
        return 'assets/icon/success.svg';
      case 'rechazado':
        return 'assets/icon/refuse.svg';
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
      default:
        return 'assets/icon/process.svg';
    }
  }

  shouldUseBlackText(estatus: string | null | undefined): boolean {
    switch(estatus?.toLowerCase()) {
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
        return true;
      default:
        return false;
    }
  }

  getColaboradorNombre(): string {
    if (this.solicitud?.colaboradorNombres && this.solicitud?.colaboradorApellidos) {
      return `${this.solicitud.colaboradorNombres} ${this.solicitud.colaboradorApellidos}`;
    }
    return 'N/A';
  }

  verArchivo( id : number, name : string, nameDownload : string | null){
    this.loading = true;
    this.sgmmService.descargarArchivo( id, name )
    .pipe(takeUntil(this.$onDestroy), finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }))
    .subscribe({
        next: (blob) => {
          saveAs(blob, nameDownload || name);
          this.message.success(`Archivo ${nameDownload || name} descargado correctamente`);
        },
        error: (error) => {
          console.error('Error al descargar archivo:', error);
          this.message.error('Error al descargar el archivo. Intente nuevamente.');
        }
      });
  }

  obtenerLeyenda(){
    let motivoRechazoIds = this.detalle?.map(item => item.motivoRechazoId) || [];    
    const nullCount = motivoRechazoIds.filter(id => id === null || id === undefined).length;
    const nonNullCount = motivoRechazoIds.filter(id => id !== null && id !== undefined).length;    
    if (nullCount === motivoRechazoIds.length) {
      this.alertStatus = { success: true, info: false, error: false };
    } else if (nullCount > 0 && nonNullCount > 0) {
      this.alertStatus = { success: false, info: true, error: false };
    } else if (nonNullCount === motivoRechazoIds.length) {
      this.alertStatus = { success: false, info: false, error: true };
    } else {
      this.alertStatus = { success: false, info: false, error: false };
    }
    this.cdr.detectChanges();
  }

  hasRejectionReason(archivo: FacturaDetalle): boolean {
    return archivo.motivoRechazoId !== null && archivo.motivoRechazoId !== undefined;
  }

  getRejectionReason(archivo: FacturaDetalle): string {
    return archivo?.motivoRechazo ?? 'Sin motivo especificado';
  }
}
